<template>
<footer class="mt-auto">
    <div class="relative max-w-6xl px-4 pb-2 mx-auto sm:px-6 sm:py-4">
        <div class="flex items-center justify-between text-sm">

            <ul class="flex justify-center justify-end order-1 my-auto mt-6 mb-4 ml-4 md:mb-0 sm:mt-0">
                <li><a href="/faqs" target="_blank"><p class='footer-link' style="margin-right: 15px;margin-top: -4px;">FAQs</p></a></li>
                <li><a href="https://foxway.co.uk/privacy-policy" target="_blank"><p class='footer-link' style="margin-right: 15px;margin-top: -4px;">Privacy Policy</p></a></li>
                <li><a href="https://wholesale.foxway.com/sales-terms" target="_blank"><p class='footer-link' style="margin-right: 15px;margin-top: -4px;">Product Sale T&Cs</p></a></li>
                <li><a href="https://foxway.co.uk/terms-of-website-use" target="_blank"><p class='footer-link' style="margin-right: 15px;margin-top: -4px;">Terms of use</p></a></li>
                <li><a class="flex items-center justify-center transition duration-150 ease-in-out footer-link fv tc nr"
                        href="https://x.com/foxwayuk" target="_blank" style="outline: none;"><i class="fa-brands fa-x-twitter"></i></a></li>
                <li class="ml-4"><a
                        class="flex items-center justify-center transition duration-150 ease-in-out footer-link fv tc nr"
                        href="https://www.linkedin.com/company/foxway-uk"  target="_blank"  style="outline: none;"><i class="fab fa-linkedin"></i></a></li>
            </ul>
            <div class="flex mt-2 text-center text-gray-400 sm:mr-4 sm:text-left sm:mt-0">
                <p> © {{year}} Foxway Circular UK Ltd</p>
            </div>
        </div>
    </div>
</footer>
</template>

<script>
export default {
    props: {
        year:  Number
    }
}
</script>
